const TheFyzz = (state = [],action) => {

  let rtn

  switch (action.type) {

      case 'ADD_FILM_DATA' :

        //console.log(action);

        // Join arrays
           let films = (state.filmData)? state.filmData.data : []

                //console.log(state.filmData);

                films = films.concat(action.payload)


              //console.log('films',films.length);

         rtn = {
            ...state,
            filmData : { data : films}

         }

        return rtn;

      case 'ADD_OPTIONS_DATA' :

        //console.log(action);

        rtn = {
            ...state,
            optionsData : { data : action.payload.acf}
         }

        return rtn;


      case 'ADD_PAGES_DATA' :

        //console.log(action);

        rtn = {
            ...state,
            pagesData : { data : action.payload}
         }

        return rtn;

      case 'ADD_PEOPLE_DATA' :

          //console.log(action);

          rtn = {
              ...state,
              peopleData : { data : action.payload}
           }

          return rtn;

      case 'ADD_TESTIMONIAL_DATA' :

          //console.log(action);

          rtn = {
              ...state,
              testimonialData : { data : action.payload}
           }

          return rtn;
      default :
        return state

  }

}

export default TheFyzz



// WEBPACK FOOTER //
// ./src/reducers/TheFyzz.js